import { render, staticRenderFns } from "./ManipulativeIconView.vue?vue&type=template&id=ad36b7e6&scoped=true&"
import script from "./ManipulativeIconView.vue?vue&type=script&lang=js&"
export * from "./ManipulativeIconView.vue?vue&type=script&lang=js&"
import style0 from "./ManipulativeIconView.vue?vue&type=style&index=0&id=ad36b7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad36b7e6",
  null
  
)

export default component.exports